import type { RequestGroup } from "@medplum/fhirtypes";
import { REQUEST_GROUP_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useRequestGroupSubscription = createSubscriptionHook<RequestGroup>(
  "RequestGroup",
  REQUEST_GROUP_COLLECTION_NAME,
);
